import { render, staticRenderFns } from "./NewClient.vue?vue&type=template&id=4ca492ef&scoped=true&lang=pug"
import script from "./NewClient.vue?vue&type=script&lang=js"
export * from "./NewClient.vue?vue&type=script&lang=js"
import style0 from "./NewClient.vue?vue&type=style&index=0&id=4ca492ef&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca492ef",
  null
  
)

export default component.exports